/**
 * 菜单通用方法
 * goToOneTab：跳转页面
 */
import router from "@/router";
import store from "@/store";
import MENUCONFIG from "@/config/menu-config.js";
const goToOneTab = function(data = {}) {
  const path = data.path;
  if (data.name) {
    //按name形式跳转
    router.push({
      name: data.name,
      params: data.params || null
    });
  } else if (data.path) {
    //按path形式跳转
    router.push({
      path: "/" + path,
      query: data.query || null
    });
  }
};

const openOneTab = function(path) {
  const pathPre = path.substring(0, 1);
  if (pathPre == "/") {
    path = path.replace("/", "");
  }

  const menuObj = MENUCONFIG.PATHMAP[path] || null;

  if (window.sessionStorage) {
    window.sessionStorage.setItem("ACTIVEPATH", path);
  }

  if (menuObj) {
    store.commit("home/addOrGoTab", menuObj);
  }
};

/**
 * 刷新当前路由
 */
const reloadRouter = function() {
  store.commit("home/setIsReload", true);
  setTimeout(() => {
    store.commit("home/setIsReload", false);
  });
};

export default {
  goToOneTab,
  reloadRouter,
  openOneTab
};



// WEBPACK FOOTER //
// ./src/common/menu-common.js